import { ChannelGroup } from '@shure/shared/angular/data-access/system-api/models';

const aecReferenceChannelSortingMap = new Map<ChannelGroup, number>([
	[ChannelGroup.AuxOutput, 1],
	[ChannelGroup.MixOutput, 2],
	[ChannelGroup.DanteLineOutput, 3],
	[ChannelGroup.PcInput, 4],
	[ChannelGroup.PcOutput, 5],
	[ChannelGroup.VirtualAudioInput, 6],
	[ChannelGroup.VirtualAudioOutput, 7],
	[ChannelGroup.DanteMicInput, 8],
	[ChannelGroup.DanteInput, 9],
	[ChannelGroup.DanteAuxInput, 10],
	[ChannelGroup.DanteLineInput, 11],
	[ChannelGroup.AuxInput, 12],
	[ChannelGroup.AnalogAuxInput, 13],
	[ChannelGroup.UsbInput, 14],
	[ChannelGroup.MobileInput, 15],
	[ChannelGroup.Automix, 16]
]);

export function getAecReferenceChannelPriority(channelGroup: ChannelGroup): number {
	return aecReferenceChannelSortingMap.get(channelGroup) ?? 0;
}
